import ICategory from "../../interfaces/ICategory";



export const requestCategories = "REQUEST_FETCH_CATEGORIES";
const successFetchCategories = "SUCCESS_FETCH_CATEGORIES";
const failureFetchCategories = "FAILURE_FETCH_CATEGORIES";
const appendToCategoryList = "APPEND_TO_CATEGORY_LIST";

// FETCH LOCATION TYPES
export interface IRequestFetchCategories {
    type: typeof requestCategories;
}

interface ISuccessFetchCategories {
    type: typeof successFetchCategories;
    payload: { categories: ICategory[] };
}

interface IFailureFetchCategories {
    type: typeof failureFetchCategories;
    payload: { error: Error };
}

interface IAppendToCategoryList {
    type: typeof appendToCategoryList;
    payload: { categories: ICategory[] };
}



export type ICategoryAction
    = IRequestFetchCategories
    | ISuccessFetchCategories
    | IFailureFetchCategories

    | IAppendToCategoryList
    ;

export const createRequestFetchCategories = (): IRequestFetchCategories => ({
    type: requestCategories,
});

export const createSuccessFetchCategories = (categories: ICategory[]): ISuccessFetchCategories => ({
    type: successFetchCategories,
    payload: { categories },
});

export const createFailureFetchCategories = (error: Error): IFailureFetchCategories => ({
    type: failureFetchCategories,
    payload: { error },
});


export const createAppendToCategoryList = (categories: ICategory[]): IAppendToCategoryList => ({
    type: appendToCategoryList,
    payload: { categories },
});


